<template>
  <b-row align-h="center">
    <div class="w-75">
      <b-col cols="12">
        <FITFormCard>
          <div slot="header">
            <b-row align-v="center">
              <b-col cols="7">
                <p class="h5">{{ $t('my.profile.header') }}</p>
              </b-col>
              <!-- <b-col cols="4" class="text-right"> -->
              <!--               <b-row align-v="center">
                <b-col cols="6" class="text-right">
                  <label class="mb-0 mx-0 align-middle">{{ $t('general.language') }}</label>
                </b-col>
                <b-col cols="6" class="text-left">
                  <b-select :options="languages" v-model="form.language" @change="onLanguageChanged"></b-select>
                </b-col>
              </b-row> -->
              <!-- </b-col> -->
              <b-col cols="5" class="text-right">
                <b-button variant="warning" size="md" class="text-white" @click="changePassword"><i class="fa fa-key mr-2"></i> Change Password</b-button>
              </b-col>
            </b-row>
          </div>
          <div slot="formBody">
            <b-row>
              <b-col cols="6" class="border-right border-light">
                <p class="h3"><i class="fa fa-user-circle mr-2"></i>{{ $t('my.profile.personalInformation') }}</p>
                <dd>
                  <ProfileRow :title="$t('my.profile.agentCode')" :value="form.agentCode"></ProfileRow>
                  <ProfileRow :title="$t('my.profile.chineseName')" :value="form.chineseName"></ProfileRow>
                  <ProfileRow :title="$t('my.profile.englishName')" :value="form.englishName"></ProfileRow>
                  <!-- <ProfileRow :title="$t('general.gender')" :value="form.gender"></ProfileRow> -->
                  <!-- <ProfileRow :title="$t('general.identityCardNo')" :value="form.identityCardNo"></ProfileRow> -->
                  <!-- <ProfileRow :title="$t('general.dateOfBirth')" :value="form.dateOfBirth | date"></ProfileRow> -->
                </dd>
              </b-col>
              <b-col cols="6">
                <p class="h3"><i class="fa fa-phone-square mr-2"></i>{{ $t('my.profile.contactInformation') }}</p>
                <dd>
                  <!-- <ProfileRow :title="$t('general.companyAddress')" :value="form.englishCompanyAddress"></ProfileRow> -->
                  <!-- <ProfileRow class="mb-3" :title="$t('general.chineseCompanyAddress')" :value="form.chineseCompanyAddress"></ProfileRow> -->
                  <ProfileRow :title="$t('general.residentialAddress')" :value="form.englishResidentialAddress"></ProfileRow>
                  <!-- <ProfileRow class="mb-3" :title="$t('general.chineseResidentialAddress')" :value="form.chineseResidentialAddress"></ProfileRow> -->
                  <ProfileRow :title="$t('general.correspondenceAddress')" :value="form.englishCorrespondenceAddress"></ProfileRow>
                  <!-- <ProfileRow class="mb-3" :title="$t('general.chineseCorrespondenceAddress')" :value="form.chineseCorrespondenceAddress"></ProfileRow> -->
                  <ProfileRow :title="$t('general.email')" :value="form.email"></ProfileRow>
                  <!-- <ProfileRow :title="$t('general.fax')" :value="form.fax"></ProfileRow> -->
                  <ProfileRow :title="$t('general.telephoneHome')" :value="form.telephoneHome"></ProfileRow>
                  <ProfileRow :title="$t('general.telephoneMobile')" :value="form.telephoneMobile"></ProfileRow>
                  <ProfileRow :title="$t('general.telephoneOffice')" :value="form.telephoneOffice"></ProfileRow>
                </dd>
              </b-col>
            </b-row>
            <b-row class="border-top border-secondary mt-3 py-3">
              <b-col cols="12">
                <p class="h3"><i class="fa fa-address-card mr-2"></i>{{ $t('my.profile.licenseInformation.header')}}</p>
              </b-col>
              <b-col cols="5" class="border-right border-light">
                <p class="lead">{{ $t('my.profile.licenseInformation.oci.header') }}</p>
                <dd>
                  <ProfileRow :title="$t('my.profile.licenseInformation.oci.ociLicensePrinciples')" :value="form.ociLicensePrinciples"></ProfileRow>
                  <ProfileRow :title="$t('my.profile.licenseInformation.oci.ociLicenseGeneral')" :value="form.ociLicenseGeneral"></ProfileRow>
                  <ProfileRow :title="$t('my.profile.licenseInformation.oci.ociLicenseLongTerm')" :value="form.ociLicenseLongTerm"></ProfileRow>
                  <ProfileRow :title="$t('my.profile.licenseInformation.oci.ociLicenseLinkedLongTerm')" :value="form.ociLicenseLinkedLongTerm"></ProfileRow>
                  <ProfileRow :title="$t('my.profile.licenseInformation.oci.ociLicenseTravel')" :value="form.ociLicenseTravel"></ProfileRow>
                </dd>
              </b-col>
              <b-col cols="7">
                <p class="lead">{{ $t('my.profile.licenseInformation.sfc.header') }}</p>
                <b-row>
                  <b-col cols="6">
                    <dd>
                      <ProfileRow :title="$t('my.profile.licenseInformation.sfc.sfcLicenseType1')" :value="form.sfcLicenseType1"></ProfileRow>
                      <ProfileRow :title="$t('my.profile.licenseInformation.sfc.sfcLicenseType2')" :value="form.sfcLicenseType2"></ProfileRow>
                      <ProfileRow :title="$t('my.profile.licenseInformation.sfc.sfcLicenseType3')" :value="form.sfcLicenseType3"></ProfileRow>
                      <ProfileRow :title="$t('my.profile.licenseInformation.sfc.sfcLicenseType4')" :value="form.sfcLicenseType4"></ProfileRow>
                      <ProfileRow :title="$t('my.profile.licenseInformation.sfc.sfcLicenseType5')" :value="form.sfcLicenseType5"></ProfileRow>
                    </dd>
                  </b-col>
                  <b-col cols="6">
                    <dd>
                      <ProfileRow :title="$t('my.profile.licenseInformation.sfc.sfcLicenseType6')" :value="form.sfcLicenseType6"></ProfileRow>
                      <ProfileRow :title="$t('my.profile.licenseInformation.sfc.sfcLicenseType7')" :value="form.sfcLicenseType7"></ProfileRow>
                      <ProfileRow :title="$t('my.profile.licenseInformation.sfc.sfcLicenseType8')" :value="form.sfcLicenseType8"></ProfileRow>
                      <ProfileRow :title="$t('my.profile.licenseInformation.sfc.sfcLicenseType9')" :value="form.sfcLicenseType9"></ProfileRow>
                      <ProfileRow :title="$t('my.profile.licenseInformation.sfc.sfcLicenseType10')" :value="form.sfcLicenseType10"></ProfileRow>
                    </dd>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-row class="border-top border-secondary mt-3 py-3">
              <b-col cols="12">
                <p class="h3"><i class="fa fa-address-card mr-2"></i>{{ $t('my.profile.cpd.header') }}</p>
              </b-col>
              <b-col cols="6">
                <dd>
                  <ProfileRow :title="$t('adm.cpd.list.mpfCorePoint')" :value="form.cpdPoints.mpfCorePoint +' '+ $t('my.profile.cpd.pts')"></ProfileRow>
                  <ProfileRow :title="$t('adm.cpd.list.mpfNonCorePoint')" :value="form.cpdPoints.mpfNonCorePoint +' '+ $t('my.profile.cpd.pts')"></ProfileRow>
                  <ProfileRow :title="$t('adm.cpd.list.mpfPoint')" :value="form.cpdPoints.mpfPoint +' '+ $t('my.profile.cpd.pts')"></ProfileRow>
                  <ProfileRow :title="$t('adm.cpd.list.normalPoint')" :value="form.cpdPoints.normalPoint +' '+ $t('my.profile.cpd.pts')"></ProfileRow>
                </dd>
              </b-col>
              <b-col cols="12" class="border-right border-light">
                <b-table :items="form.cpdPoints.trainings" :fields="trainingFields">
                  <template slot="providerName" slot-scope="row">
                    <div>{{ row.value | isEmpty }}</div>
                  </template>
                  <template slot="providerName" slot-scope="row">
                    <div>{{ row.value | isEmpty }}</div>
                  </template>
                  <template slot="trainingType" slot-scope="row">
                    <div>{{getTranslatedValue(locale, 'My', 'trainingType', row.value) }}</div>
                  </template>
                </b-table>
              </b-col>
            </b-row>
          </div>
        </FITFormCard>
      </b-col>
    </div>
  </b-row>
</template>
<script type="text/javascript">
import Vue from 'vue';
import ProfileRow from './ProfileRow';
import { mapGetters } from 'vuex';
import {
  FITFormCard,
  FITSelect,
  FITSearchableTable
} from '@/components';

export default {
  name: 'Profile',
  components: {
    ProfileRow,
    FITFormCard,
    FITSelect,
    FITSearchableTable
  },
  computed: {
    ...mapGetters(['getTranslatedValue']),
    locale() {
      return this.$i18n.locale;
    },
  },
  data() {
    return {
      trainingFields: {
        providerName: {
          label: this.$t('my.profile.cpd.training.provider')
        },
        trainingName: {
          label: this.$t('my.profile.cpd.training.provider')
        },
        trainingType: {
          label: this.$t('my.profile.cpd.training.type')
        },
        trainingDate: {
          label: this.$t('my.profile.cpd.training.date')
        },
        trainingTime: {
          label: this.$t('my.profile.cpd.training.time')
        },
        point: {
          label: this.$t('my.profile.cpd.pts')
        }
      },
      languages: [{
        text: 'English',
        value: 'english'
      }, {
        text: '繁體中文',
        value: 'zh_hk'
      }, {
        text: '简体中文',
        value: 'zh_cn'
      }],

      yesNo: [{
        'Y': 'Yes',
        'N': 'No'
      }],

      form: { language: 'english', correspondenceAddress: '', companyAddress: '', residentialAddress: '', chineseName: '', englishName: '', "ID": "42", "agentCode": "010000010", "contact": "2586", "agentTeam": "1", "position": "M", "agentType": "A", "status": "", "joinDate": null, "leaveDate": null, "cibLicense": null, "mpfaLicense": "", "ociLicensePrinciples": "", "ociLicenseGeneral": "", "ociLicenseLongTerm": "", "ociLicenseLinkedLongTerm": "", "ociLicenseTravel": "", "sfcLicenseType1": "", "sfcLicenseType2": "", "sfcLicenseType3": "", "sfcLicenseType4": "", "sfcLicenseType5": "", "sfcLicenseType6": "", "sfcLicenseType7": "", "sfcLicenseType8": "", "sfcLicenseType9": "", "sfcLicenseType10": "", "commAgentRatio": "0.5", "commOverrideRatio": "0.15", "version": "2", "createTime": "2018-03-28 18:33:18", "updateTime": "2018-07-02 15:31:00", "createUser": "4", "updateUser": "4", "title": "Ms", "englishLastname": "Chan", "englishFirstname": "Tsz Ching", "chineseLastname": "陳", "chineseFirstname": "梓晴", "nationality": "Chinese (Hong Kong)", "identityCardNo": "Y244647(7)", "idType": "HKID", "gender": "F", "dateOfBirth": "1992-07-08 00:00:00", "maritalStatus": "S", "contactType": "", "defaultAddress": "2642", "telephoneMobile": "", "telephoneHome": "", "telephoneOffice": "", "fax": "", "email": "", "chineseResidentialAddress": "", "englishResidentialAddress": "", "chineseCorrespondenceAddress": "", "englishCorrespondenceAddress": "", "chineseCompanyAddress": "", "englishCompanyAddress": "", "invalidAddress": "N", cpdPoints: { trainings: [], corePoints: 0, nonCorePoints: 0, totalPoints: 0 } }
    }
  },
  created() {

    this.$store.dispatch('My/getProfile')
      .then((json) => {
        let data = json.data;
        let result = {
          ...data,
          chineseName: data.chineseLastname + data.chineseFirstname,
          englishName: data.englishLastname.toUpperCase() + ' ' + data.englishFirstname,
          englishCorrespondenceAddress: `${this.$options.filters.isEmpty(`${data.englishCorrespondenceAddress}`)}`,
          chineseCorrespondenceAddress: `${this.$options.filters.isEmpty(`${data.chineseCorrespondenceAddress}`)}`,
          englishCompanyAddress: `${this.$options.filters.isEmpty(`${data.englishCompanyAddress}`)}`,
          chineseCompanyAddress: `${this.$options.filters.isEmpty(`${data.chineseCompanyAddress}`)}`,
          englishResidentialAddress: `${this.$options.filters.isEmpty(`${data.englishResidentialAddress}`)}`,
          chineseResidentialAddress: `${this.$options.filters.isEmpty(`${data.chineseResidentialAddress}`)}`,
          cpdPoints: data.cpdPoints
        };
        Vue.set(this, 'form', result);
      }).catch((error) => {
        console.error(error);
      })
    this.$store.dispatch('getAllSelections', 'training')
      .then((json) => {
        this.$store.commit('My/setSelections', {
          selections: json.data,
        })
      });

  },
  methods: {
    onLanguageChanged(value) {
      this.$store.dispatch('My/editPreference', {
        language: value,
        version: this.form.version
      }).then(() => {
        if (value === 'english')
          value = 'en_us';

        this.$i18n.locale = value;
      });
    },

    changePassword() {
      this.$router.push('/my/changePassword');
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/My/components/Profile/Profile.vue